/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { CloseCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Col, Row, message } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import UPDATE_APP, { UpdateAppData, UpdateAppVars } from 'shared/graphql/mutation/updateApp';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button, Text } from 'shared/components';
import { StyledModal } from './Styles';

type ModalConfirmDeletePaymentVoucherProps = {
  appId: string;
  paymentVouchersId: string[];
  paymentVoucher: {
    id: string;
    createDate: string;
    voucherNumber: string;
    roundPaid: string;
    payeeFullName: string;
    grandTotalPrice: number;
  };
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmDeletePaymentVoucher: React.FC<ModalConfirmDeletePaymentVoucherProps> = (
  props,
) => {
  const { onCancel, visible, paymentVouchersId, paymentVoucher, appId } = props;
  const [updateApp, { loading }] = useMutation<UpdateAppData, UpdateAppVars>(UPDATE_APP, {
    update: (_cache, { data }) => {
      if (data?.updateApp._id) {
        message.success('ลบรายการใบสำคัญจ่ายแล้ว');
        onCancel();
      }
    },
    onError: (err) => {
      message.error(err.message);
    },
    refetchQueries: () => ['App', 'AppStatus', 'Apps'],
  });

  const confirmUpdate = () => {
    updateApp({
      variables: {
        _id: appId,
        payment_voucher: paymentVouchersId,
      },
    });
  };

  return (
    <StyledModal
      className="custom-modal"
      title="ยืนยันลบใบสำคัญจ่ายหรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<DeleteOutlined />}
          color="red"
          onClick={() => confirmUpdate()}
          loading={loading}
        >
          ลบใบสำคัญจ่าย
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>รหัสใบสำคัญจ่าย:</Col>
        <Col span={18}>
          <Text strong>{paymentVoucher.voucherNumber}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>มูลค่าใบแจ้งหนี้:</Col>
        <Col span={18}>
          <Text strong customType="primary">
            {formatCurrency(paymentVoucher.grandTotalPrice)}
          </Text>
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmDeletePaymentVoucher;
